import ArchivedOCDS from ".";
import withAdminDashboard from "../HOC/withAdminDashboard";

export default withAdminDashboard(ArchivedOCDS);
